(function ($) {
  function setHeights() {
    var contentHeight = $(".banner-with-form .img-wrap").outerHeight();
    var logoGridHeight = $(".banner-with-form .row-wrap .logo-grid").outerHeight();
    var totalHeight = contentHeight + logoGridHeight;
    $(".banner-with-form .row-wrap .logo-grid").css("top", contentHeight - 30);
    $(".banner-with-form .row-wrap").css("min-height", totalHeight);
  }

  $(document).ready(setHeights);
  $(window).on("load resize", setHeights);
  console.log('test')
  jQuery(document).ready(function($) {
    $('.btn-wrap  a.form-button ').on('click', function(e) {
      e.preventDefault();
      let script = document.createElement('script');
      script.setAttribute('data-hubspot-rendered', 'true');
      let data_id_form = e.currentTarget.getAttribute('data-id-form')
      let form_id = data_id_form == "#" ? "0b93b12e-54cb-4f89-aa4c-1002ed335bce" : data_id_form
      console.log(data_id_form)
      script.innerHTML = `hbspt.forms.create({ region: "na1", portalId: "3424022", formId: "${form_id}"});`;
      document.querySelector('.form-overlay .form-overlay-item').appendChild(script)
      $('.form-overlay').addClass('overlay-active');
    });
  });

  jQuery(document).on('click keydown', function(e) {
    var clickedElement = e.target;
    let hb_script = document.querySelector('.form-overlay .form-overlay-item [data-hubspot-rendered="true"]');
    let hb_form = document.querySelector('.form-overlay .form-overlay-item .hbspt-form');
    if (
      $(clickedElement).hasClass('close-button') ||
      $(clickedElement).hasClass('container')
    ) {
      $('.form-overlay').removeClass('overlay-active');
      hb_script.remove()
      hb_form.remove()
    } else if (e.key === 'Escape') {
      $('.form-overlay').removeClass('overlay-active');
      hb_script.remove()
      hb_form.remove()
    }
  });
  
})(jQuery);
